import { defineQuery, Not } from "bitecs";
import { ModelComponent } from "../components/ModelComponent";
import { MovementGoalComponent } from "../components/MovementGoalComponent";
import { PositionComponent } from "../components/PositionComponent";
import { TagTouchedComponent } from "../components/TagTouchedComponent";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createMovementSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    movementSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const PET_SPEED = 0.001;

    const query = defineQuery([
        MovementGoalComponent,
        PositionComponent,
        ModelComponent,
        Not(TagTouchedComponent),
    ]);

    return {
        movementSystem: (world: TinyPetsWorld) => {
            query(world).forEach((eid: number) => {
                const position = [
                    PositionComponent.x[eid],
                    PositionComponent.y[eid],
                    PositionComponent.z[eid],
                ];
                const target = [
                    MovementGoalComponent.x[eid],
                    MovementGoalComponent.y[eid],
                    MovementGoalComponent.z[eid],
                ];

                // Distance is the speed of the entity, hardcoded for now
                const distance = PET_SPEED * world.time.delta;

                // Calculate vector position -> target as target - position
                const direction = target.map((v, i) => v - position[i]);

                // Normalize vector by dividing by it's length
                const length = Math.hypot(...direction);
                const normalizedDirection = direction.map((v) => v / length);

                // Move distance by multiplying normalized vector by it
                const moveDistance = normalizedDirection.map(
                    (v) => v * distance
                );

                // Find final position by adding move to the current position
                const finalPosition = position.map(
                    (v, i) => v + moveDistance[i]
                );

                // Update position component with final position
                PositionComponent.x[eid] = finalPosition[0];
                PositionComponent.y[eid] = finalPosition[1];
                PositionComponent.z[eid] = finalPosition[2];
            });

            return world;
        },
    };
};
